import React from 'react'
import PropTypes from 'prop-types'
import ActivityTable from './ActivityTable'
import { useStateValue } from '@State'

const ActivityTablesContainer = () => {
  let [currentState] = useStateValue()
  let actsExist = false
  for (let i = 0; i < currentState.groups.length; i++) {
    if (currentState.groups[i].activities.length > 0) {
      actsExist = true
      break
    }
  }
  return (
    <div className="card-myed">
      {actsExist ? (
        currentState.groups.map((group, index) => {
          if (group.activities.length > 0) {
            return <ActivityTable group={group} key={index} index={index} />
          }
        })
      ) : (
        <h4 className="text-center">
          There are currently no available activities.
        </h4>
      )}
    </div>
  )
}

ActivityTablesContainer.propTypes = {
  activities: PropTypes.array,
}

export default ActivityTablesContainer
